import { useModalState } from "@/contexts/modal/Context.tsx";
import CalendarIllustration from "@/components/ui/CalendarIllustration.tsx";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

interface Props {
  date: string;
  hour: string;
}

export default function RequestDiplomaNotificationModal() {
  const { data } = useModalState();
  const { date, hour } = data as Props;
  const { t } = useTranslation();
  return (
    <div>
      <header className={"flex flex-col items-center"}>
        <p className={"!text-secondary text-2xl text-center font-semibold"}>
        {t("diploma_request.modal.already_scheduled")}
        </p>
      </header>
      <div className={"flex flex-col justify-center h-full"}>
        <div className=" flex flex-row items-center justify-center w-full gap-10">
          <CalendarIllustration
            className="w-[135px] h-[135px] rounded-md"
            header={dayjs(date).format("ddd")}
            day={dayjs(date).format("DD")}
            month={dayjs(date).format("MMM")}
          />
          <div className="flex flex-col items-start gap-4">
            <div className={"gap-0 flex-col items-start"}>
              <h5 className={"font-semibold"}>
                {" "}
                {t("diploma_request.modal.time")}
              </h5>
              <p className={"text-3xl font-semibold text-brand-secondary"}>
                {hour}
              </p>
            </div>
            <div className={"detail gap-0  flex-col items-start large"}>
              <h5 className={"font-semibold"}>
                {" "}
                {t("diploma_request.modal.duration")}
              </h5>
              <p className={"text-3xl font-semibold text-brand-secondary"}>
                20&nbsp;{t("diploma_request.modal.minutes")}
              </p>
            </div>
          </div>
        </div>
      </div>
      <p className="text-sm  w-full text-center text-brand">
        {t("diploma_request.modal.reschedule_message")}
      </p>
    </div>
  );
}
